/**
 * One "Archived" switch replaces the old Active / Archived / All dropdown.
 * Off shows active records, on shows archived ones. "All" was never a view
 * anyone needed: a record is either live or it is in the archive.
 *
 * Pages still pass the filter around as the string 'active' | 'archived'
 * (their services and the header's window events already speak that), so
 * these two functions are the only place the switch and the string meet.
 */
export type ArchiveView = 'active' | 'archived';

export const toArchiveView = (archivedOn: boolean): ArchiveView => (archivedOn ? 'archived' : 'active');

/** True only for the archive view. A stale 'all' from older state reads as off. */
export const isArchiveView = (view: string | null | undefined): boolean => view === 'archived';
